module.exports = __webpack_public_path__ + "static/media/marc.8880a65c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/faces/marc.jpg
// module id = 546
// module chunks = 0